import { FilterType, DataType, CellType } from '@colven/common-domain-lib/lib';
import i18n from '@/i18n';

export const headers = (lang,  headersOptions) => {
  return [
    {
      text: i18n.t('currentState.HEADERS.EQUIPMENT', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      width: 100,
      value: 'thingName',//
    },
    {
      text: i18n.t('currentState.HEADERS.EQUIPMENT_TYPE', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      width: 100,
      value: 'typeName',
    },
    {
      text: i18n.t('currentState.HEADERS.ENTERPRISE', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      width: 135,
      value: 'enterpriseName',//
    },
    {
      text: i18n.t('currentState.HEADERS.EVENT', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      cellType: CellType.iconText,
      width: 150,
      cellConfig: {
        icon: 'eventIcon',
        color: 'eventColor',
      },
      value: 'eventName',
    },
    {
      text: i18n.t('currentState.HEADERS.ENGINE_STATE', { lang }),
      align: 'left',
      filterType: FilterType.multiSelect,
      selected: true,
      sortable: true,
      options: headersOptions.engineState,
      type: DataType.boolean,
      cellType: CellType.textBackgroundColor,
      width: 140,
      cellConfig: {
        round: true,
        color: 'engineStateColor',
      },
      value: 'engineState',//
    },
    {
      text: i18n.t('currentState.HEADERS.SPEED', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.number,
      width: 170,
      value: 'speed',
    },
    {
      text: i18n.t('currentState.HEADERS.ODOMETER', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.number,
      value: 'odometer',
    },
    {
      text: i18n.t('currentState.HEADERS.HOURMETER', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      value: 'hourMeter',
    },
    {
      text: i18n.t('currentState.HEADERS.POSITION_TIMESTAMP', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      cellType: CellType.textBackgroundColor,
      width: 200,
      cellConfig: {
        round: false,
        outlined: true,
        color: 'positionTimestampColor',
      },
      value: 'positionTimestamp',//
    },
    {
      text: i18n.t('currentState.HEADERS.COMUNICATION_TIMESTAMP', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      cellType: CellType.textBackgroundColor,
      width: 210,
      cellConfig: {
        round: false,
        outlined: true,
        color: 'comunicationTimestampColor',
      },
      value: 'comunicationTimestamp',//
    },
    {
      text: i18n.t('currentState.HEADERS.UBICATION', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      value: 'ubication',//
      width: 200,
    },
    {
      text: i18n.t('currentState.HEADERS.REFERENCE', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      value: 'reference',
      width: 200,
    },
    {
      text: i18n.t('currentState.HEADERS.DRIVER', { lang }),
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      value: 'driverName',
      width: 100,
    },
    {
      text: 'GPS ID',
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      value: 'gpsId',
      width: 100,
    },
    {
      text: 'Coordenadas',
      align: 'left',
      filterType: FilterType.textField,
      selected: true,
      sortable: true,
      type: DataType.string,
      value: 'coordinates',
      width: 100,
    },
   
  ];
};


